import { render, staticRenderFns } from "./DashboardWidgetApplicationsNewItem.vue?vue&type=template&id=6d4678d3&scoped=true&lang=pug&"
import script from "./DashboardWidgetApplicationsNewItem.vue?vue&type=script&lang=js&"
export * from "./DashboardWidgetApplicationsNewItem.vue?vue&type=script&lang=js&"
import style0 from "./DashboardWidgetApplicationsNewItem.vue?vue&type=style&index=0&id=6d4678d3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4678d3",
  null
  
)

export default component.exports